module.exports = __webpack_public_path__ + "img/news4.7eb4bc56.jpg";